// extracted by mini-css-extract-plugin
export default {"showVariablesContainer":"NavTemplateItems_showVariablesContainer__evvyZ","switchContainer":"NavTemplateItems_switchContainer__JTtqz"};